import React from 'react';

import useCreateProjectCards from '../../../hooks/useCreateProjectCards';
import ProjectCard from './ProjectCard';

import scss from './ProjectCreateDashboard.module.scss';

const ProjectCreateDashboard = () => {
  const cardsData = useCreateProjectCards();

  return (
    <div className={scss.cardsList}>
      {cardsData.map(({ title, description, logo, path, disabled }) => (
        <ProjectCard key={title} title={title} description={description} logo={logo} path={path} disabled={disabled} />
      ))}
    </div>
  );
};

export default ProjectCreateDashboard;
